module.exports = __webpack_public_path__ + "img/sad-emoji.513ca9f3.png";